import React, { useContext, useState } from 'react';
import './LoginModal.css';
import { api }        from '../services/api';
import { jwtDecode }  from 'jwt-decode';
import { AuthCtx }    from '../context/AuthContext';
import { AFFILIATIONS } from '../constants/affiliations';
import { REGIONS }      from '../constants/regions';
import { useLocation } from 'react-router-dom';

export default function LoginModal() {
  const { token, setToken } = useContext(AuthCtx);
  const { pathname } = useLocation();


  const { search } = useLocation();
  const params      = new URLSearchParams(search);
  const justResetOK = params.get('reset') === 'ok';




  const skip =
  pathname.startsWith('/verificar-email') ||
  pathname.startsWith('/verificado')      ||
  pathname.startsWith('/reset');   

  /* ►►  Si YA hay token → nada que mostrar  */
  //if (token) return null;
  if (token || skip) return null;

  const [isReg , setIsReg ]   = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email:'', password:'', repitpassword:'', fullname:'', 
    afiliacion:'', region:'',consentimiento:false
  });

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleCheck = e =>
    setForm({ ...form, consentimiento: e.target.checked });

  const forgot = async () => {
    const email = prompt('Ingresa tu correo registrado:');
    if (email) await api.post('/clientes/forgot', { email });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      /* ---------- REGISTRO ---------- */
      if (isReg) {
        const p = form.fullname.trim().split(/\s+/);
        if (p.length < 2) { alert('Ingrese al menos nombre y un apellido'); return; }

        const nombre     = p.slice(0, p.length - 1).join(' ');
        const ap_paterno = p[p.length - 1];
        const ap_materno = p.length > 2 ? p[p.length - 2] : '';

        await api.post('/clientes/register', {
            nombre,
            ap_paterno,
            ap_materno,
            email    : form.email.trim().toLowerCase(),
            password : form.password.trim(),
            afiliacion:form.afiliacion,
            region    :form.region,
            consentimiento : form.consentimiento          

        });
        alert('Revisa tu correo para verificar la cuenta');
        setIsReg(false);
        return;
      }

      /* ---------- LOGIN ---------- */
      const { data } = await api.post('/clientes/login', {
        email   : form.email.trim().toLowerCase(),
        password: form.password.trim(),
      });

      const jwt = data.access_token;
      setToken(jwt);                           // << clave: actualiza contexto

      /* Guarda nombre completo para el header */
      const { nombre, ap_paterno, ap_materno } = jwtDecode(jwt);
      localStorage.setItem(
        'clienteNombre',
        `${nombre} ${ap_paterno} ${ap_materno}`,
      );
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ------------- UI ------------- */
  return (
    <div className="login-container">
      <div className={`container ${isReg ? 'active' : ''}`}>
        {/* ============ LOGIN ============ */}
        <div className="form-box login">
          <form onSubmit={handleSubmit}>
            <h1>Ingresar</h1>


  {/* Mensaje de contraseña actualizada */}
  {justResetOK && (
      <div className="success-message">
        ✔ Contraseña actualizada correctamente. Por favor inicia sesión.
      </div>
    )}


            <div className="input-box">
              <input
                type="email"
                name="email"
                placeholder="Correo"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                name="password"
                placeholder="Contraseña"
                value={form.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="forgot-link">
              <a href="#!" onClick={forgot}>Olvidé mi contraseña?</a>
            </div>

            <button type="submit" className="btn" disabled={loading}>
              {loading ? '...' : 'Login'}
            </button>
          </form>
        </div>

        {/* ============ REGISTRO ============ */}
        <div className="form-box register">
          <form onSubmit={handleSubmit}>
            <h1>Regístrate</h1>


            <div className="input-box">
              <input
                type="text"
                name="fullname"
                placeholder="Nombres y Apellidos"
                value={form.fullname}
                onChange={handleChange}
                required
              />
              <i className="bx bxs-user" />
            </div>

            <div className="input-box">
              <input
                type="email"
                name="email"
                placeholder="Correo"
                value={form.email}
                onChange={handleChange}
                required
              />
              <i className="bx bxs-envelope" />
            </div>


           {/* <div className="input-box">
  <select name="afiliacion" value={form.afiliacion} onChange={handleChange}>
    {AFFILIATIONS.map(op=><option key={op}>{op}</option>)}
  </select>
</div>

<div className="input-box">
  <select name="region" value={form.region} onChange={handleChange}>
    {REGIONS.map(r=><option key={r}>{r}</option>)}
  </select>
</div>  */}


<div className="input-box select-box">
  <select 
    name="afiliacion" 
    value={form.afiliacion} 
    onChange={handleChange}
    className="styled-select"
  >
    <option value="" disabled selected>Seleccione su afiliación</option>
    {AFFILIATIONS.map(op => (
      <option key={op} value={op}>{op}</option>
    ))}
  </select>
  <i className="bx bxs-briefcase-alt" />
</div>

<div className="input-box select-box">
  <select 
    name="region" 
    value={form.region} 
    onChange={handleChange}
    className="styled-select"
  >
    <option value="" disabled selected>Seleccione su región</option>
    {REGIONS.map(r => (
      <option key={r} value={r}>{r}</option>
    ))}
  </select>
  <i className="bx bxs-map" />
</div>




            <div className="input-box">
              <input
                type="password"
                name="password"
                placeholder="Contraseña"
                value={form.password}
                onChange={handleChange}
                required
              />
              <i className="bx bxs-lock-alt" />
            </div>

            <div className="input-box">
              <input
                type="password"
                name="repitpassword"
                placeholder="Repetir contraseña"
                value={form.repitpassword}
                onChange={handleChange}
                required
              />
              <i className="bx bxs-lock-alt" />
            </div>



<label className="consent-checkbox">
  <input
    type="checkbox"
    checked={form.consentimiento}
    onChange={handleCheck}
    required
  />
  <span className="consent-text">
  Se brinda consentimiento y autorización para el uso de sus datos personales expuestos, 
  dentro del marco de la Ley de Protección de Datos Personales N° 29733; este registro 
  se derivará a nuestra Dirección y se conservará durante el plazo que éste determine.  
  </span>
</label>


            {/* … (los mismos inputs que ya tenías) … */}

            <button type="submit" className="btn" disabled={loading}>
              {loading ? '...' : 'Registrar'}
            </button>
          </form>
        </div>

        {/* ============ OVERLAY ============ */}
        <div className="toggle-box">
          <div className="toggle-panel toggle-left">
            <h1>Hola, bienvenido!</h1>
            <p>¿No tienes una cuenta?</p>
            <button
              className="btn outlined"
              onClick={() => setIsReg(true)}
            >
              Regístrate
            </button>
          </div>

          <div className="toggle-panel toggle-right">
            <h1>¡Hola!</h1>
            <p>¿Ya tienes una cuenta?</p>
            <button
              className="btn outlined"
              onClick={() => setIsReg(false)}
            >
              Inicia sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
